import { useState } from "react"

import { Modal } from "wealthmode-frontend/components"
import { Box, Button, Icon, Text } from "wealthmode-frontend/gluestack/ui"
import { FunnelIcon } from "wealthmode-frontend/icons"

import type { DataTableFilters } from "@/components/DataTable"

/** Header button opening a dialog of the table's filter controls, with a summary of those applied. */
export function TableFilters({ title, filters }: { title: string; filters: DataTableFilters }) {
  const [open, setOpen] = useState(false)

  return (
    <>
      {filters.active.length > 0 ? (
        <Text className="text-sm text-foreground-secondary truncate">{filters.active.join(" • ")}</Text>
      ) : null}
      <Button
        size="sm"
        variant="outline"
        action="secondary"
        onPress={() => setOpen(true)}
        accessibilityLabel="Filter"
      >
        <Icon
          as={FunnelIcon}
          className="text-foreground-secondary h-8 w-8"
        />
      </Button>

      <Modal
        isOpen={open}
        title={`Filter ${title}`}
        close={() => setOpen(false)}
        autoSize="both"
      >
        <Box className="px-4">{filters.controls}</Box>
      </Modal>
    </>
  )
}
